import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { AlarmMask } from '../../../../shared/models/alarm-mask/alarm-mask';
import { initFlowbite } from 'flowbite';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SelectionOptionValue } from '../../../../shared/models/internal/selection-option-value';
import { SelectionComponent } from '../selection/selection.component';
import { AlarmMaskContent } from './alarm-mask-content/alarm-mask-content';
import { CommonUtils, snakeCaseToWords } from '../../../common/common-utils';
import { TranslationState } from '../../../../shared/enums/translation-state';
import { AgentActionDirective } from '../../../directives/agent-action.directive';

@Component({
  selector: 'app-alarm-mask-view',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SelectionComponent, AlarmMaskContent, AgentActionDirective],
  templateUrl: './alarm-mask-view.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './alarm-mask-view.scss',
})
export class AlarmMaskView implements AfterViewInit, OnInit, OnChanges {
  @Input() public alarmMasks: AlarmMask[] = [];
  @Input() public maskTranslationState?: TranslationState;

  public alarmMask?: AlarmMask;
  public translationState?: TranslationState;
  public alarmMaskOptions: SelectionOptionValue[] = [];
  public alarmMasksForm!: FormGroup;
  public currentAlarmMaskId!: FormControl;
  public isAlarmVisible = false;

  public commonUtils = CommonUtils;

  public ngAfterViewInit(): void {
    initFlowbite();
  }

  public ngOnInit(): void {
    this.initAlarmMasksOptions();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['alarmMasks']) {
      this.initAlarmMasksOptions();
    }
  }

  public toggleAlarmVisibility(): void {
    this.isAlarmVisible = !this.isAlarmVisible;
  }

  private initForm(): void {
    this.currentAlarmMaskId = new FormControl(null, []);

    this.alarmMasksForm = new FormGroup({});
  }

  private initAlarmMasksOptions(): void {
    if (!this.alarmMasksForm || !this.currentAlarmMaskId) {
      this.initForm();
    }
    if (this.alarmMasks && this.alarmMasks.length > 0) {
      let first = true;
      this.alarmMaskOptions = this.alarmMasks.map((mask) => {
        const item = { id: mask.id, selected: first, title: snakeCaseToWords(mask.name ?? 'unnamed') };
        if (first) {
          first = false;
        }
        this.currentAlarmMaskId.setValue(mask.id);
        this.alarmMask = mask;
        return item;
      });
    } else {
      this.alarmMask = undefined;
      this.currentAlarmMaskId.setValue('');
    }

    if (this.currentAlarmMaskId) {
      this.currentAlarmMaskId.valueChanges.subscribe(() => {
        this.displayAlarmMaskContent();
      });
    }
  }

  private displayAlarmMaskContent(): void {
    const maskId = this.currentAlarmMaskId.value;
    this.alarmMask = this.alarmMasks.find((mask) => mask.id == maskId);
  }
}
